import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../components/custom/custom-toast";
import { PAGE_SIZES } from "../../../constants/status";
import { useFetchData } from "../../../hooks/useFetch";
import { PromotionBrand } from "../../../models/response/promotion-brand";
import { API_BRANDS_ROUTER, ApiConfig } from "../../../services/api-config";
import { toggleMenuContent } from "../../../store/themeConfigSlice";
import { BrandCampaignTable } from "../components/brand-campaign-table";

export const BrandCampaignPage = () => {
  const dispatch = useDispatch();
  dispatch(toggleMenuContent("Danh sách thương hiệu đã gán khuyến mãi"));

  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(PAGE_SIZES[0]);
  const [keySearch, setKeySearch] = useState("");
  const [promotionBrands, setPromotionBrands] = useState<PromotionBrand[]>([]);

  const {
    request: getPromotionBrands,
    baseResponse: promotionBrandsRes,
    loading: tableLoading,
  } = useFetchData.Get<PromotionBrand[]>({ projectId: ApiConfig.PROJECT_ID.USER_SERVICE });

  useEffect(() => {
    const fetchData = async () => {
      const params = {};
      await getPromotionBrands({
        endPoint: API_BRANDS_ROUTER.API_GET_BRAND_PROMOTIONS(),
        data: params,
      });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!promotionBrandsRes) return;
    if (promotionBrandsRes?.data && promotionBrandsRes?.status === 200) {
      setPromotionBrands(promotionBrandsRes.data);
    } else {
      showToast({
        message: promotionBrandsRes?.message ?? "Không thể tải danh sách khuyến mãi",
        type: "error",
      });
    }
  }, [promotionBrandsRes]);

  return (
    <div className="flex flex-col gap-3">
      <BrandCampaignTable
        tableLoading={tableLoading}
        data={promotionBrands ?? []}
        keySearch={keySearch}
        setKeySearch={setKeySearch}
        page={page}
        setPage={setPage}
        pageSize={limit}
        setPageSize={setLimit}
      />
    </div>
  );
};
